import script from "./SubmitAccord.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitAccord.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__